const getErrorType = (data) => (typeof data?.error_type === 'string' ? data.error_type : '');
const ASK_AI_UPGRADE_FEATURE = 'ask_ai';

export const requiresSuartePlusForAskAi = (data) =>
  getErrorType(data) === 'AI_WEEKLY_LIMIT_REACHED'
  && data?.error_data?.upgrade_feature === ASK_AI_UPGRADE_FEATURE;

export const isAiHourlyQuotaReached = (data) =>
  getErrorType(data) === 'AI_HOURLY_LIMIT_REACHED';

export const resolveWeeklyAiQuotaMessage = (data, t) => {
  const resetAt = new Date(data?.error_data?.resets_at);
  if (Number.isNaN(resetAt.getTime())) {
    return t('errors.weekly_limit');
  }

  return t('errors.weekly_limit_with_reset', { resetAt: resetAt.toLocaleString() });
};

const getResetTimeText = (resetsAt, t) => {
  if (!resetsAt) return null;
  const resetDate = new Date(resetsAt);
  if (Number.isNaN(resetDate.getTime())) return null;

  const msLeft = resetDate.getTime() - Date.now();
  if (msLeft <= 0) return t('errors.time_less_than_minute');

  const minutesLeft = Math.ceil(msLeft / 60_000);
  if (minutesLeft <= 1) return t('errors.time_one_minute');

  return t('errors.time_minutes', { count: minutesLeft });
};

export const resolveAiAccessErrorMessage = (data, t) => {
  const errorType = getErrorType(data);

  if (errorType === 'AI_HOURLY_LIMIT_REACHED') {
    const timeLeft = getResetTimeText(data?.error_data?.resets_at, t);
    return timeLeft
      ? t('errors.hourly_limit_with_time', { time: timeLeft })
      : t('errors.hourly_limit');
  }

  if (errorType === 'AI_WEEKLY_LIMIT_REACHED') {
    return t('errors.weekly_limit');
  }

  if (errorType === 'AI_VISITOR_REQUIRED') {
    return t('errors.visitor_required');
  }

  return t('errors.unable_to_answer');
};
